declare const __BUILD_ID__: string;

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';
import { initMonitoring } from '@/shared/lib/monitoring';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

// Инициализируем мониторинг
initMonitoring();

// Build ID for cache busting
console.log('Build ID:', __BUILD_ID__);
// Force cache refresh — guided tour v2 (dark text, arrows, finish step)
console.log('v10-guided-tour-fix');

// Регистрируем Service Worker для офлайн-поддержки
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW регистрация не критична — игнорируем ошибки
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
